<template>
  <div class="app-wrapper custom-scroll-y">
    <div class="navbar">
      <div class="logo-container">
        <img src="@/assets/logo.png" alt="Thundersend" class="logo-img" />
        <span class="logo-text">Thundersend</span>
      </div>
      <div class="nav-container" :class="{ 'mobile-nav': isMobile, 'show-menu': showMenu }">
        <div class="menu-background">
          <router-link
            v-for="(item, index) in menuItems"
            :key="index"
            :to="item.path"
            class="menu-item"
            :class="{ active: isActive(item.path) }"
            @click.native="closeMenu"
          >
            {{ $t(item.name) }}
          </router-link>
        </div>
      </div>

      <div class="nav-container">
        <div class="menu-background">
          <router-link
            v-for="(item, index) in menuItems"
            :key="index"
            :to="item.path"
            class="menu-item"
            :class="{ active: isActive(item.path) }"
          >
            {{ $t(item.name) }}
          </router-link>
        </div>
      </div>

      <div class="tools-container" v-if="isLogin">
        <div class="tools-background">
          <div class="notification">
            <i class="el-icon-s-opportunity"></i>
            <span class="mode_switch" :class="{ 'is-dark-switch': !isLightMode }">
              <span>{{isLightMode ? $t("layout.button.closeLight") : $t("layout.button.onLight")}}</span>
              <el-switch
                v-model="isLightMode"
                inactive-color="#4D4D52"
                @change="handleDarkModeChange"
                :width="50"
              >
              </el-switch>
            </span>
          </div>
          <div class="language-switch mar_right">
            <el-dropdown @command="changeLanguage">
              <span class="el-dropdown-link">
                {{ currentLanguage === "zh_CN" ? "中文" : "English" }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh_CN">中文</el-dropdown-item>
                <el-dropdown-item command="en">English</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="avatar" @click="viewProfile">
            <el-avatar
              :size="32"
              :src="
                currentPerson.headImage
                  ? '/jbl/api/file/view-stream/' + currentPerson.headImage
                  : require('@/assets/default-avatar.png')
              "
              v-if="currentPerson"
            ></el-avatar>
          </div>
        </div>
      </div>
      <div class="login-container" v-else>
        <el-switch
          v-model="isLightMode"
          active-color="rgba(0, 0, 0, 0.6)"
          inactive-color="#F1F1F1"
          @change="handleDarkModeChange"
          class="mar_right"
        >
        </el-switch>
        <div class="language-switch mar_right">
          <el-dropdown @command="changeLanguage">
            <span class="el-dropdown-link">
              {{ currentLanguage === "zh_CN" ? "中文" : "English" }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh_CN">中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <router-link to="/login">{{ $t("layout.button.login") }}</router-link>
      </div>
       <!-- 添加汉堡菜单按钮 -->
       <div v-if="isMobile" class="mobile-menu-btn" @click="toggleMenu">
        <i class="el-icon-menu"></i>
      </div>
    </div>

    <div class="main-container">
      <router-view />
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import { getCurrentPerson, getCurrentUser } from '@/api/user'
export default {
  name: 'Layout',
  components: {
    Footer,
  },
  data() {
    return {
      menuItems: [
        { name: 'layout.menu.home', path: '/home' },
        { name: 'layout.menu.hot', path: '/hot' },
        { name: 'layout.menu.mine', path: '/mine' },
        { name: 'layout.menu.insight', path: '/insight' },
        { name: 'layout.menu.subscribe', path: '/subscribe' },
        { name: 'layout.menu.notice', path: '/notice' }
      ],
      isLogin: false,
      currentPerson: null,
      currentUser: null,
      isLightMode: false,
      currentLanguage: null,
      showMenu: false,
      isMobile: false
    }
  },
  methods: {
    isActive(path) {
      if (path === '/') {
        return this.$route.path === '/'
      }
      return this.$route.path.startsWith(path)
    },
    // 切换语言方法
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.currentLanguage = lang;
      localStorage.setItem('language', lang);
      window.location.reload();
    },
    // 初始获取当前人员
    async getCurrentPerson() {
      const res = await getCurrentPerson();
      localStorage.setItem('currentPerson', JSON.stringify(res));
      const userRes = await getCurrentUser();
      localStorage.setItem('user', JSON.stringify(userRes));
      this.currentPerson = res;
      this.currentUser = userRes;
    },
    viewProfile() {
      this.$router.push('/profile');
    },
    handleDarkModeChange(e) {
      this.$store.commit('theme/changeTheme', e);
      localStorage.setItem('isLightMode', JSON.stringify(e));
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      if(this.isMobile) {
        this.showMenu = false;
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 480;
    }
  },
  created() {
    if (localStorage.getItem('_token')) {
      this.isLogin = true
      this.getCurrentPerson();
    } else {
      this.menuItems.splice(2, 1);
    }
    if (localStorage.getItem('language')) {
      this.currentLanguage = localStorage.getItem('language')
    } else {
      this.currentLanguage = 'zh_CN'
    }
    if (this.$store.state.theme.isLightMode) {
        this.isLightMode = this.$store.state.theme.isLightMode;
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  }
}
</script>

<style lang="scss" scoped>
  .notification {
    color: var(--default-color);
    font-size: 14px;
    > i {
      vertical-align: middle;
      color: var(--liayout-light-icon) !important;
    }
  }
.app-wrapper {
  height: 100vh;
  background-color: var(--page-bg);
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  backdrop-filter: blur(8px);

  .logo-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    .logo-img {
      width: 28px;
      height: 28px;
      margin-right: 8px;
    }

    .logo-text {
      font-size: 18px;
      font-weight: 600;
      color: var(--default-color);
      letter-spacing: -0.2px;
    }
  }
  // 添加移动端相关样式
  .mobile-menu-btn {
    font-size: 24px;
    color: var(--default-color);
    cursor: pointer;
    z-index: 1001;
    margin-left: -6px;
  }

  .nav-container {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;

    .menu-background {
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 6px;
      background: var(--layout-header-bg);
      border-radius: 30px;
      border: 1px solid rgba(255, 255, 255, 0.04);

      .menu-item {
        position: relative;
        height: 32px;
        line-height: 32px;
        padding: 0 16px;
        margin: 0 2px;
        color: var(--default-color);
        font-size: 15px;
        font-weight: 600;
        text-decoration: none;
        border-radius: 6px;
        transition: all 0.2s ease;

        &:hover {
          background: var(--layout-header-select-bg);
          border-radius: 60px;
        }

        &.active {
          background: var(--layout-header-select-bg);
          border-radius: 20px;
        }
      }
    }
  }

  .tools-container {
    flex-shrink: 0;

    .tools-background {
      display: flex;
      align-items: center;
      height: 40px;
      background: var(--tool-bg);
      border-radius: 8px;
      border: 1px solid var(--tool-border);
      padding: 0 8px;

      .notification {
        padding: 0 12px;
        cursor: pointer;

        i {
          font-size: 20px;
          color: var(--title-text);
          transition: color 0.2s ease;

          &:hover {
            color: var(--title-text);
          }
        }
      }

      .divider {
        width: 1px;
        height: 20px;
        background: rgba(255, 255, 255, 0.08);
        margin: 0 4px;
      }

      .avatar {
        padding: 0 8px;
        cursor: pointer;

        :deep(.el-avatar) {
          border: 2px solid rgba(255, 255, 255, 0.1);
          transition: border-color 0.2s ease;

          &:hover {
            border-color: rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
}

.main-container {
  padding: 88px 0 24px;
}

:deep(.el-badge__content.is-dot) {
  width: 6px;
  height: 6px;
  right: -2px;
  top: -2px;
  border: none;
  box-shadow: 0 0 0 2px rgba(26, 27, 31, 0.95);
}

.mar_right {
  margin-right: 16px;
}

.language-switch {
  display: inline-block;
  cursor: pointer;
}
.el-dropdown-link {
  font-size: 14px;
  color: var(--default-color);
}
.mode_switch {
  position: relative;
  > span {
    position: absolute;
    z-index: 1;
    left: 7px;
    font-size: 10px;
    top: 3px;
    color: rgba(255, 255, 255, 0.6);
    pointer-events: none;
  }
}

.is-dark-switch {
  > span {
    right: 6px;
    left: auto;
  }
}
@media screen and (max-width: 480px) {
  .mobile-menu-btn {
    display: block;
  }

  .navbar {
    padding: 0 16px;

    .nav-container {
      display: none;
      .menu-background {
        flex-direction: column;
        height: auto;
        padding: 16px;
        border-radius: 12px;

        .menu-item {
          width: 100%;
          margin: 8px 0;
          text-align: center;
        }
      }
    }
    .mobile-nav {
      position: fixed;
      top: 64px;
      left: 0;
      right: 0;
      transform: none;
      background: var(--layout-header-bg);
      padding: 16px;
      display: none;
    }
    .show-menu {
      display: block;
    }
    .tools-container {
      .tools-background {
        padding: 0 4px;
        background: transparent;
        border: 0;
        
        .notification {
          padding: 0 8px;
          .el-icon-s-opportunity {
            display: none;
          }
        }
      }
    }
  }
}
</style>